import { PIAPI } from '@core/base';
import { CreateTaskRequest, TaskResponse } from '@core/types';
import { FaceSwapConfig, FaceSwapParams, FaceSwapOutput } from './types';

export class FaceSwapAPI extends PIAPI {
    private config: FaceSwapConfig;

    constructor(apiKey: string, config: FaceSwapConfig = {}, baseUrl?: string) {
        super(apiKey, baseUrl);
        this.config = config;
    }

    private createFaceSwapRequest(params: FaceSwapParams): CreateTaskRequest {
        if (!params.target_image) {
            throw new Error("target_image is required");
        }
        if (!params.swap_image) {
            throw new Error("swap_image is required");
        }

        const request: CreateTaskRequest = {
            model: "Qubico/image-toolkit",
            task_type: "face-swap",
            input: params,
        };

        return request;
    }

    async faceSwap(params: FaceSwapParams): Promise<TaskResponse<FaceSwapOutput>> {
        const request = this.createFaceSwapRequest(params);
        return this.createTask<FaceSwapOutput>(request);
    }

    async faceSwapAndWait(params: FaceSwapParams, options?: {
        maxAttempts?: number;
        interval?: number;
    }): Promise<TaskResponse<FaceSwapOutput>> {
        const request = this.createFaceSwapRequest(params);
        return this.createTaskAndWait<FaceSwapOutput>(request, options);
    }

    async getFaceSwapTask(taskId: string): Promise<TaskResponse<FaceSwapOutput>> {
        return this.getTask<FaceSwapOutput>(taskId);
    }
}
